import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";

import { DffError, getErrorDetails } from "@dffedb/util";

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: "error",
    templateUrl: "./error.component.html",
    styleUrls: ["./error.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent implements OnChanges {
    @Input() public error: any;
    public message = "";
    public logId = "";
    public details = "";
    public detailsVisible = false;

    public async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (changes["error"]?.currentValue !== changes["error"]?.previousValue) {
            this.message = getMessage(changes["error"].currentValue);
            this.logId = getLogId(changes["error"].currentValue);
            this.details = await getDetails(changes["error"].currentValue);
        }
    }
}

async function getDetails(error: any): Promise<string> {
    return getErrorDetails(error);
}

function getMessage(error: any): string {
    return (error && (error.friendlyMessage || error.message || error)) || "Der er opstået en ukendt fejl";
}

function getLogId(error: any): string {
    return error instanceof DffError ? error.logId : "";
}
